export const getQuantityText = (quantity: number, numberOfPacks: number, sticksInPack: number) =>
  `${quantity * numberOfPacks} packs (${quantity * numberOfPacks * sticksInPack} sticks)`;
